import { Grid, TableCell, TableRow } from "@mui/material";
import React from "react";
import DateInput from "../../../../components/DateInput";
import { DecimalFormControl, DecimalOrEmptyFormControl, IntegerOrEmptyFormControl } from "../../../../components/FormControl";
import { green } from "@mui/material/colors";
import { validateDecimal, validateDecimalOrEmpty, validateInteger, validateIntegerOrEmpty } from "../../../../utils/validation";
import { inputValueToDecimal, inputValueToDecimalOrNull, inputValueToInt } from "../../../../utils/utils";
import { getDisplaySize } from "../../../../utils/Items";

const validateOrderPrice = (orderPriceValue) => {
  return validateIntegerOrEmpty(orderPriceValue || "");
}

const validateOrderQuantity = (orderQuantityValue) => {
  return validateDecimalOrEmpty(orderQuantityValue || "");
}

const validateOrder = (order) => {
  return (
    validateOrderPrice(order.orderPrice?.toString())
      && validateOrderQuantity(order.orderQuantity?.toString())
  );
}

const OrderTableRow = React.memo(({order, orderControl, keyHandler, isShippingDateUndecided}) => {

  const priceTableColumnSx = {
    fontSize: 18,
  };

  const handleChangeValue = (prop, v) => {

    const newOrderValue = {
      ...order,
      [prop] : v
    }

    orderControl.changeOrderValue({
      [prop] : v,
      isError: !validateOrder(newOrderValue)
    });
  };

  const getBackgroundColor = (order) => {
    return order.marketPriceDetailId ? null : green[50];
  }

  const {registerComponent} = keyHandler;

  return (    
    <TableRow
      sx={{
        alignItems: "baseline",
        bgcolor: getBackgroundColor(order)
      }}
    >
      <TableCell
        component="th"
        scope="row"
        sx={{
          ...priceTableColumnSx,
          fontWeight: "bold",
          fontSize: 20,
          height: 28,
          width: "20%",
          minWidth: "220px",
        }}
      >
        {order.productName}
      </TableCell>
      <TableCell
        sx={{ ...priceTableColumnSx, width: "16%", minWidth: "150px" }}
      >
        {order.originName}
      </TableCell>
      <TableCell
        sx={{ ...priceTableColumnSx, width: "21%", minWidth: "175px" }}
      >
        {
          getDisplaySize(
            order.rankName,
            order.productClassName,
            order.weight,
            order.weightUnitName,
            order.packingName,
            order.orderingUnitQuantity       
          )
        }
      </TableCell>
      <TableCell
        sx={{
          ...priceTableColumnSx,
          width: "13%",
          minWidth: "10px",
          padding: 1
        }}
      >
        <IntegerOrEmptyFormControl
          value={order.orderPrice?.toLocaleString() || ""}
          setValue={(v) => handleChangeValue("orderPrice", validateInteger(v) ? inputValueToInt(v) : v)}
          inputProps={{
            sx: { ...priceTableColumnSx, textAlign: "right" },
          }}
          onBlurFormat={(v) => validateInteger(v) ? inputValueToInt(v).toLocaleString() : v}
          sx={{ width: 130 }}
          helperTextSx={{mx: 0, width: 130}}
          {...registerComponent(0)}
        />
      </TableCell>
      
      <TableCell
        sx={{...priceTableColumnSx, width: "10%", minWidth: "100px", padding: 1}}
      >
        <Grid container alignItems="center">
          <Grid item>
            <DecimalOrEmptyFormControl
              value={order.orderQuantity?.toLocaleString() || ""}
              setValue={(v) => handleChangeValue("orderQuantity", validateDecimal(v) ? inputValueToDecimal(v).toString() : v)}
              inputProps={{
                sx: { ...priceTableColumnSx, textAlign: "right" },
              }}
              onBlurFormat={(v) => validateDecimal(v) ? inputValueToDecimal(v).toString() : v}
              sx={{ width: 80 }}
              helperTextSx={{mx: 0, width: 80}}
              {...registerComponent(1)}
            /> 
          </Grid>
          <Grid item>
            {order.orderingUnitName}
          </Grid>
        </Grid>
      </TableCell>

      <TableCell
        sx={{ ...priceTableColumnSx, width: "14%", minWidth: "150px" }}
      >
        {order.remarks}
      </TableCell>

      {
        isShippingDateUndecided
          ?
            <TableCell
              sx={{...priceTableColumnSx, width: "12%", minWidth: "120px", padding: 1}}
            >
              <DateInput
                inputProps={{
                  sx: { ...priceTableColumnSx },
                }}
                value={order.shippingDateScheduled}
                setValue={(v) => handleChangeValue("shippingDateScheduled", v)}
                {...registerComponent(2)}
              />
            </TableCell>
          : null
      }
    </TableRow>
  )
})

export default OrderTableRow;

